document.addEventListener("DOMContentLoaded", () => {

    /* =========================
       Header Scroll Effect
    ========================= */

    const header = document.querySelector(".rr-header");

    window.addEventListener("scroll", () => {

        if (window.scrollY > 40) {

            header?.classList.add("scrolled");

        } else {

            header?.classList.remove("scrolled");

        }

    });


    /* =========================
       Premium Search Button
    ========================= */

    const searchButton = document.querySelector(".rr-search-btn");
    const searchModal = document.querySelector("#search-modal");

    if (searchButton && searchModal) {

        searchButton.addEventListener("click", (e) => {

            e.preventDefault();

            // Open Shopify dialog
            searchModal.dispatchEvent(
                new CustomEvent("dialog-component:open", {
                    bubbles: true
                })
            );

            // Fallback
            const dialog = searchModal.querySelector("dialog");

            if (dialog && !dialog.open) {
                dialog.showModal();
            }

            // Focus search field
            setTimeout(() => {

                const input = searchModal.querySelector(".search-input");

                input?.focus();

            }, 150);

        });

    }

});
const cartButton = document.querySelector(".rr-cart-btn");

cartButton?.addEventListener("click", () => {

    const drawer = document.querySelector("#cart-drawer");

    if (!drawer) return;

    // Open Shopify's cart drawer
    drawer.setAttribute("open", "");

    drawer.dispatchEvent(
        new CustomEvent("open", { bubbles: true })
    );

});
/* ===============================
   REPLICA RACK CART DRAWER
================================ */

const cartBtn = document.querySelector(".rr-cart-btn");

cartBtn?.addEventListener("click", function (e) {

    e.preventDefault();

    const drawer = document.querySelector("#cart-drawer");

    if (!drawer) return;

    const dialog = drawer.querySelector("dialog");

    if (dialog && !dialog.open) {
        dialog.showModal();
    }

});